<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

  <sc-dialog-title>{{'routing position selection' |
    translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.select-routing-position.title',
    translationService.language]}}</sc-dialog-title>

  <sc-separator-line></sc-separator-line>


  <sc-flex-fitting-content [vertical]="true">

    <div style="height: 100%;">
      <sc-padding [fitHeight]="true">
        <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

          <sc-dictionary-label defaultValue="please select a position"
            dictionaryKey="tmc-yard.widgets.sac-client.manage-planned-assignments.select-routing-position.description">
          </sc-dictionary-label>

          <sc-content-spacer [vertical]="false"></sc-content-spacer>

          <sc-flex-fitting-content [vertical]="true">
            <form [formGroup]="formGroup">
              <mat-radio-group formControlName="selectedOption">
                <sc-flex [vertical]="true" [stretchContent]="true">
                  <mat-radio-button value="{{option.routingPositionId}}"
                    *ngFor="let option of routingPositionOptions">{{option.label}}</mat-radio-button>
                </sc-flex>
              </mat-radio-group>
            </form>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-padding>
    </div>

  </sc-flex-fitting-content>

  <sc-separator-line></sc-separator-line>

  <sc-actionbar>
    <app-service-response></app-service-response>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button mat-dialog-close>{{'cancel' |
      translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.select-routing-position.action.cancel',
      translationService.language]}}</button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-stroked-button [disabled]="selectedOptionId == null" (click)="onSelectClicked()">{{'select' |
      translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.select-routing-position.action.select',
      translationService.language]}}</button>
  </sc-actionbar>


</sc-flex>
